import { css } from "@emotion/react";
import { SizeType } from "antd/lib/config-provider/SizeContext";

export const rowStyle = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
`;

export const checkboxGroupStyle = css`
  margin-left: 28px;
  > label {
    display: flex;
  }
`;

export const pushRightStyle = css`
  margin-left: auto;

  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

const sizeHeightPx: Record<Exclude<SizeType, undefined>, number> = {
  large: 40,
  middle: 32,
  small: 24,
};

// `allowClear` makes antd wrap the input in `.ant-input-affix-wrapper`, which
// renders a couple px shorter than the addon search button. Pin both to the
// matching size height so they line up. Remove if `allowClear` is dropped.
export const searchStyle = (size: SizeType) => css`
  .ant-input-affix-wrapper,
  .ant-input-search-button {
    height: ${sizeHeightPx[size ?? "large"]}px;
  }

  @media only screen and (max-width: 992px) {
    width: 100% !important;
  }
`;
